import React from 'react';
import { Button, Typography, Alert } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { SimpleModal, Icon } from '@livable/saas-react-components';
import useStyles from './styles';
export const AutoBillingSimpleInfoModal = observer(_ref => {
  let titleText = _ref.titleText,
    bodyText = _ref.bodyText,
    customTrigger = _ref.customTrigger,
    iconType = _ref.iconType;
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const classes = useStyles();
  const internalTrigger = /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    'custom-attribute': '195-AutoBillingSimpleInfoModal'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  }), /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, t('add_new_property_flow.activate_auto_billing')));
  const ModalContent = _ref2 => {
    let handleModalClose = _ref2.handleModalClose;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.modalContent)
    }, /*#__PURE__*/React.createElement(Alert, {
      severity: 'info',
      icon: false,
      size: "small",
      variant: "modal"
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "h4",
      component: "p"
    }, /*#__PURE__*/React.createElement("div", {
      className: classes.textContent
    }, bodyText)))), /*#__PURE__*/React.createElement("div", {
      className: classes.modalFooter
    }, /*#__PURE__*/React.createElement(Button, {
      variant: "text",
      onClick: handleModalClose,
      'custom-attribute': '196-AutoBillingSimpleInfoModal'
    }, t('general.done'))));
  };
  const Title = () => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.modalTitleText)
    }, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.statusIcon)
    }, iconType && /*#__PURE__*/React.createElement(Icon, {
      type: iconType
    })), titleText || t('add_new_property_flow.activate_auto_billing')));
  };
  return /*#__PURE__*/React.createElement(SimpleModal, {
    noFooter: true,
    noPadding: true,
    title: /*#__PURE__*/React.createElement(Title, null),
    trigger: customTrigger !== undefined ? customTrigger : internalTrigger
  }, /*#__PURE__*/React.createElement(ModalContent, null));
});